import { Component } from '@angular/core';
import { ParallaxDirective } from '../../shared/parallax.directive';
import { Hero } from '../../shared/hero/hero';
import { AppointmentInfo } from '../../shared/appointment-info/appointment-info';
import { PriceList } from '../../shared/price-list/price-list';
import { GalleryGrid } from '../../shared/gallery-grid/gallery-grid';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    ParallaxDirective,
    Hero,
    AppointmentInfo,
    PriceList,
    GalleryGrid,
  ],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home {}


